<template>
    <section class="tile is-child box">

        <nav class="breadcrumb is-medium" aria-label="breadcrumbs">
            <ul class="p-l-md">
                <li v-if="$route.matched[0].meta.schoolType !== 'eschool'">
                    <router-link :to="{ name: 'highschool-categories'}">
                        {{ $t('shop.offers.list') }}
                    </router-link>
                </li>
                <li v-else>
                    <router-link :to="{ name: 'eshop-categories'}">
                        {{ $t('shop.offers.list') }}
                    </router-link>
                </li>
                <li class="is-active"><a class="has-text-weight-light title is-5">{{ currentCategory }}</a></li>
            </ul>
            <hr>
        </nav>

        <div v-if="category && category.has_sessions">
            <transition name="component-fade" mode="out-in">
                <component
                        :is="filtersView"
                        :offerFilter="true"
                        @filter="filterSessions">
                </component>
            </transition>
        </div>


        <div>
            <section v-if="isLoading" class="m-b-lg">
                <b-notification :closable="false" type="is-white" :class="'section'">
                    <b-loading :is-full-page="false" :active.sync="isLoading" :can-cancel="false"></b-loading>
                </b-notification>
            </section>

            <div v-if="isFilteredSessions && sessions.length" :class="isLoading ? 'is-invisible':''">
                <div class="is-size-4 has-text-weight-light is-italic heading-line m-b-lg" >
                    Résultats trouvés: {{ pagination.total }}
                </div>

                <div>
                    <nav class="pagination pagination-top p-b-lg" v-if="pagination.total_pages > 1">

                        <ul class="pagination-list">
                            <li v-for="pageNumber in pagination.total_pages"
                                v-if="Math.abs(pageNumber - pagination.current_page) < 5 || pageNumber === pagination.total_pages || pageNumber === 1">
                                <a @click="setPage(pageNumber)" class="pagination-link page-number button"
                                   :class="{'is-primary': pagination.current_page === pageNumber, last: (pageNumber === pagination.total_pages && Math.abs(pageNumber - pagination.current_page) > 5), first:(pageNumber === 1 && Math.abs(pageNumber - pagination.current_page) > 5)}">{{
                                    pageNumber }}</a>
                            </li>
                        </ul>
                        <a class="pagination-previous" @click="prevPage('scrollTop')" v-if="pagination.current_page !== 1">Précédent</a>
                        <a class="pagination-next" @click="nextPage('scrollTop')" v-if="pagination.current_page !== pagination.total_pages">Suivant</a>
                    </nav>

                </div>

                <transition-group name="slide-fade">

                    <div v-for="session in sessions" class="columns offer-session" :key="session.id">
                        <div class="column is-one-quarter-desktop session-image">
                            <figure class="image is-3by2 m-b-none">
                                <img :src="randomImage(session.offer)" alt="">
                            </figure>
                        </div>
                        <div class="column is-5 session-text">
                            <div class="heading-line title has-text-weight-light">
                                <span v-if="$route.matched[0].meta.schoolType !== 'eschool'">
                                    <router-link class="has-text-primary" :to="{ name: 'highschool-offer', params: { offerId: session.offer.id }, query: {session: session.id}}">
                                        {{ session.offer.name.fr }}
                                    </router-link>
                                </span>
                                <span v-else>
                                    <router-link class="has-text-primary" :to="{ name: 'eshop-offer', params: { offerId: session.offer.id }, query: {session: session.id}}">
                                        {{ session.offer.name.fr }}
                                    </router-link>
                                </span>
                            </div>
                            <div class="subtitle is-5 is-italic">{{ session.campus.name }}</div>
                        </div>


                        <div class="column session-price has-text-white has-text-centered has-vertically-aligned-content has-background-primary">

                            <div>
                                <i class="is-size-4 has-text-weight-light">{{ formatDate(session.begin) }} - {{ formatDate(session.end) }}</i>
                            </div>
                            <hr>


                            <div class="m-t-md">

                                <div class="columns">
                                    <div class="column p-sm">
                                        <span class="is-size-4" v-if="session.prices.length">{{ offerFees(session.prices) }}</span>
                                        <span class="is-size-4" v-else>{{ offerFees(session.offer.prices) }}</span>
                                        <div class="columns has-text-centered is-multiline m-t-sm">
                                            <div class="column" v-for="candidate in candidates" v-if="candidate.applications && candidate.applications.choices">
                                                <button v-if="isSelectedCandidate({candidate, session:session.id})"
                                                        class="button has-background-white-ter"
                                                        disabled>
                                                    {{ $t('shop.offers.register') }}
                                                </button>
                                                <button v-else
                                                        class="button has-background-primary has-text-light"
                                                        @click="addSessionChoiceToCart({candidate, offer:session.offer, school, session, type:'internat'})" >
                                                    {{ $t('shop.offers.register') }}
                                                </button>

                                            </div>
                                            <div class="column" v-if="!isLoggedIn || !hasCandidates">
                                                <button v-if="isSelectedGuestSessionChoice({candidate:null, offer:session.offer, session})"
                                                        class="button has-background-white-ter"
                                                        disabled>
                                                    {{ $t('shop.offers.book') }}
                                                </button>
                                                <button v-else
                                                        class="button has-background-primary has-text-light"
                                                        @click="guestChoice({candidate:null, offer:session.offer, school, session, type:'internat'})">
                                                    {{ $t('shop.offers.book') }}
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="column p-sm border-left" v-if="externshipSessionFees(session.prices) || externshipOfferFees(session.offer.prices)">
                                        <span class="is-size-4" v-if="externshipSessionFees(session.prices)">{{ offerExternshipFees(session.prices) }}</span>
                                        <span class="is-size-4" v-else>{{ offerExternshipFees(session.offer.prices) }}</span>
                                        <div class="columns has-text-centered is-multiline m-t-sm">

                                            <div class="column" v-for="candidate in candidates" v-if="candidate.applications && candidate.applications.choices">
                                                <button class="button has-background-white-ter"
                                                        v-if="isSelectedCandidate({candidate, session:session.id})"
                                                        disabled>
                                                    {{ $t('shop.offers.register') }}
                                                </button>
                                                <button class="button has-background-primary has-text-light"
                                                        @click="addSessionChoiceToCart({candidate, offer:session.offer, school, session, type:'externat'})" v-else>
                                                    {{ $t('shop.offers.register') }}
                                                </button>

                                            </div>
                                            <div class="column" v-if="!isLoggedIn || !hasCandidates">
                                                <button class="button has-background-white-ter"
                                                        v-if="isSelectedGuestSessionChoice({candidate:null, offer:session.offer, session})"
                                                        disabled>
                                                    {{ $t('shop.offers.book') }}
                                                </button>
                                                <button class="button has-background-primary has-text-light"
                                                        @click="guestChoice({candidate:null, offer:session.offer, school, session, type:'externat'})" v-else>
                                                    {{ $t('shop.offers.book') }}
                                                </button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition-group>

                <div>
                    <nav class="pagination pagination-botom p-t-lg" v-if="pagination.total_pages > 1">

                        <ul class="pagination-list">
                            <li v-for="pageNumber in pagination.total_pages"
                                v-if="Math.abs(pageNumber - pagination.current_page) < 5 || pageNumber === pagination.total_pages || pageNumber === 1">
                                <a @click="setPage(pageNumber)" class="pagination-link page-number button"
                                   :class="{'is-primary': pagination.current_page === pageNumber, last: (pageNumber === pagination.total_pages && Math.abs(pageNumber - pagination.current_page) > 5), first:(pageNumber === 1 && Math.abs(pageNumber - pagination.current_page) > 5)}">{{
                                    pageNumber }}</a>
                            </li>
                        </ul>
                        <a class="pagination-previous" @click="prevPage('scrollTop')" v-if="pagination.current_page !== 1">Précédent</a>
                        <a class="pagination-next" @click="nextPage('scrollTop')" v-if="pagination.current_page !== pagination.total_pages">Suivant</a>
                    </nav>

                </div>

            </div>

        </div>


        <div class="columns is-multiline" v-if="!isFilteredSessions && !isLoading && school">

            <div class="column is-one-third-desktop is-half-tablet" v-for="(offer,index) in offers" :key="index">
                <div class="card-image" v-if="$route.matched[0].meta.schoolType !== 'eschool'">
                    <router-link class="has-text-white" :to="{ name: 'highschool-offer', params: { offerId: offer.id }}">
                        <figure class="image is-3by2 m-b-none">
                            <img :src="randomImage(offer)" alt="">
                        </figure>
                        <div class="is-overlay is-clipped">
                            <h2 class="card-footer-item title is-5 is-italic has-text-white has-text-weight-light  is-primary-opacity">
                                {{ offer.name.fr }}
                            </h2>
                        </div>
                    </router-link>
                </div>
                <div class="card-image" v-else>
                    <router-link class="has-text-white" :to="{ name: 'eshop-offer', params: { offerId: offer.id }}">
                        <figure class="image is-3by2 m-b-none">
                            <img :src="randomImage(offer)" alt="">
                        </figure>
                        <div class="is-overlay is-clipped">
                            <h2 class="card-footer-item title is-5 is-italic has-text-white has-text-weight-light  is-primary-opacity">
                                {{ offer.name.fr }}
                            </h2>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>



    </section>
</template>

<script>
    import api from 'services/offers'
    import Filters from './search/Filters'
    import {mapActions, mapGetters} from 'vuex'

    export default {
        data () {
            return {
                filtersView: Filters,
                category: {},
                selectedFilter: null,
                destinations: [],
                themes: [],
                dates: [],
                durations: [],
                isLoading: false,
            }
        },
        props: {
            candidates: { type: Array },
            categoryId: { type: Number }
        },
        computed: {
            ...mapGetters(
                'sessions', [
                    'sessions',
                    'filters',
                    'isFilteredSessions',
                    'pagination'
                ]
            ),
            ...mapGetters('organization', [
                'getSchoolBySlug'
            ]),
            ...mapGetters('orders', [
                'isSelectedCandidate',
                'isSelectedGuestSessionChoice'
            ]),
            ...mapGetters('candidate', [
                'hasCandidates',
            ]),
            ...mapGetters(
                'auth', [
                    'isLoggedIn'
                ]
            ),
            offers () {
                let offers = []
              let schools = []

              if (this.school.type_id === 1) {
                schools = [1, 3]
              }
                if (this.category.offers) {
                    this.category.offers.map(function (offer) {
                        if (offer.school_type) {
                            offers.push(offer)
                        }
                    }, this)
                }
                return offers
            },
            currentCategory () {
                return this.category.name ? this.category.name.fr:''
            },
            school() {
                return this.getSchoolBySlug(this.$route.params.school)
            },

        },
        methods: {
            ...mapActions('orders', [
                'addSessionChoiceToCart',
                'addChoiceToGuestCart'
            ]),
            ...mapActions('sessions', [
                'fetchSessions',
                'filteredSessions'
            ]),
            formatDate(date) {
                const currentYear = moment().year()

                const sessionDate =moment(date, 'YYYY-MM-DD hh:mm:ss');

                if (sessionDate.year() !== currentYear) {
                    return moment(date, 'YYYY-MM-DD hh:mm:ss').format('LL')
                }else{
                    return moment(date, 'YYYY-MM-DD hh:mm:ss').format('LL').substr(0,moment(date, 'YYYY-MM-DD hh:mm:ss').format('LL').length-4)
                }
            },

            toggleFilter(filter) {
                this.selectedFilter = this.selectedFilter !== filter ? filter:null
            },
            fetchCategoryOffers () {
                api.offerCategory(this.categoryId).then((result) => {

                  if (!result.data.offers.length) {
                    this.emptyCategoryRedirect()
                  }
                    this.category = result.data
                }).catch(e => {
                })
            },
          emptyCategoryRedirect() {
            if (this.$route.meta.schoolType === 'highschool') {
              this.$router.push({name: 'highschool-categories', params: {school: this.$route.params.school}})
            }

            if (this.$route.meta.schoolType === 'eschool') {
              this.$router.push({name: 'eschool-categories', params: {school: this.$route.params.school}})
            }

            if (this.$route.meta.schoolType === 'boardingschool') {
              this.$router.push({name: 'shop-categories', params: {school: this.$route.params.school}})
            }
          },
            offerFees (prices) {
                const school = this.getSchoolBySlug(this.$route.params.school)
                let offerPrices = _.orderBy(prices, 'year', 'desc')
                return offerPrices.filter(function (price) {
                    return price.school_id === school.id
                }).map(price => price.price+' '+price.currency)[0];
            },

            externshipSessionFees (prices) {
                const school = this.getSchoolBySlug(this.$route.params.school)
                let offerPrices = _.orderBy(prices, 'year', 'desc')
                return offerPrices.filter(function (price) {
                    return price.school_id === school.id
                }).map(price => price.externship_price)[0];
            },
            externshipOfferFees (prices) {
                const school = this.getSchoolBySlug(this.$route.params.school)
                let offerPrices = _.orderBy(prices, 'year', 'desc')
                return offerPrices.filter(function (price) {
                    return price.school_id === school.id
                }).map(price => price.externship_price)[0];
            },
            offerExternshipFees (prices) {
                const school = this.getSchoolBySlug(this.$route.params.school)
                let offerPrices = _.orderBy(prices, 'year', 'desc')
                return offerPrices.filter(function (price) {
                    return price.school_id === school.id
                }).map(price => price.externship_price+' '+price.currency)[0];
            },

            sessionFees (prices) {
                const school = this.getSchoolBySlug(this.$route.params.school)
                let offerPrices = _.orderBy(prices, 'year', 'asc')
                return offerPrices.filter(function (price) {
                    return price.school_id === school.id
                }).map(price => price.price);
            },
            sessionExternshipFees (prices) {
                const school = this.getSchoolBySlug(this.$route.params.school)
                let offerPrices = _.orderBy(prices, 'year', 'asc')
                return offerPrices.filter(function (price) {
                    return price.school_id === school.id
                }).map(price => price.externship_price);
            },

            guestChoice (choice) {

                if (choice.session.prices.length) {
                    if (choice.type === 'externat') {
                        choice.offer.price = parseInt(this.sessionExternshipFees(choice.session.prices))
                    }else{
                        choice.offer.price = parseInt(this.sessionFees(choice.session.prices))
                    }

                }else{
                    if (choice.type === 'externat') {
                        choice.offer.price = parseInt(this.sessionExternshipFees(choice.offer.prices))
                    }else{
                        choice.offer.price = parseInt(this.sessionFees(choice.offer.prices))
                    }

                }
                this.addChoiceToGuestCart(choice)
            },

            randomImage (offer) {
                if (offer && offer.medias.length) {
                    let image = offer.medias[Math.floor(Math.random()*offer.medias.length)];
                    return '/img/offers/'+image.path
                }
            },
            filterSessions(filters) {
                if (filters !== null) {
                    this.isLoading = true
                    this.filters.category = this.categoryId
                    this.filters.school = this.$route.params.school
                    this.fetchSessions({
                        perPage: 30,
                        filters: filters
                    }).then(() => {
                        this.isLoading = false
                        this.filteredSessions(true)
                    })

                }else{
                    this.filteredSessions(false)
                }

            },
            setPage (page = 1) {
                const skipPage = this.pagination.per_page * (page - 1)
                if (skipPage < 0 || page > this.pagination.total_pages) return null
                this.fetchSessions({ page: page, perPage: this.pagination.per_page, filters: this.filters })
            },
            nextPage (scroll) {
                const skipPage = this.pagination.current_page + 1
                if (skipPage < 0 || this.pagination.current_page > this.pagination.total_pages) return null
                this.fetchSessions({
                    page: skipPage,
                    perPage: this.pagination.per_page,
                    filters: this.filters
                })
                if (scroll === 'scrollTop') {
                    this.$scrollTo('.pagination-top', { offset: -100 })
                }
            },
            prevPage (scroll) {
                const skipPage = this.pagination.current_page - 1
                if (skipPage < 0 || this.pagination.current_page > this.pagination.total_pages) return null
                this.fetchSessions({
                    page: skipPage,
                    perPage: this.pagination.per_page,
                    filters: this.filters
                })
                if (scroll === 'scrollTop') {
                    this.$scrollTo('.pagination-top', { offset: -100 })
                }
            },
        },
        created () {
            this.fetchCategoryOffers()
        }
    }
</script>

<style scoped>
    img {
        object-fit: cover;
    }
    .offer-session {
        margin-bottom: 1.75rem;
        background-color: white;
        border-radius: 2px;
        box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
    }

    .offer-session .session-image {
        padding: 0;
    }

    .session-text {
        padding-left: 0.75rem;
    }

    .session-price hr{
        height: 1px;
        margin:1rem 2rem;
    }

</style>
